"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBareDomain = void 0;
const function_1 = require("fp-ts/function");
const toBareDomain = (url) => (0, function_1.pipe)(url, (a) => a.trim(), (a) => a.replace(/^http:\/\//, ''), (a) => a.replace(/^https:\/\//, ''), (a) => a.replace(/^www./, ''), (a) => a.split('/')[0]);
exports.toBareDomain = toBareDomain;
